"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ItemBase = _interopRequireDefault(require("./ItemBase"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledList = /*#__PURE__*/_styledComponents.default.ol.withConfig({
  displayName: "OrderedListBase__StyledList",
  componentId: "components-web__sc-4m9lgj-0"
})({
  display: 'flex',
  flexDirection: 'column',
  listStylePosition: 'inside',
  margin: 0,
  padding: 0
});

/**
 * Semantic ordered list.
 */
const OrderedListBase = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    start = 1,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledList, {
    ...rest,
    ref: ref,
    start: start,
    children: children
  });
});
OrderedListBase.displayName = 'OrderedList';
OrderedListBase.propTypes = {
  /**
   * A list of ordered items wrapped in `OrderedListBase.Item`.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The position to start the list with.
   */
  start: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
OrderedListBase.Item = _ItemBase.default;
var _default = exports.default = OrderedListBase;